import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';

export const tokenConfig: RequestConfig = {
  requestInterceptors: [
    (config: RequestOptions) => {
      // Skip adding Authorization header for auth/refresh endpoint
      // refresh endpoint should be called with refreshToken instead.
      if (config.url && config.url.includes('/auth/refresh')) {
        return config;
      }

      // Check if accessToken exists in localStorage
      const accessToken = localStorage.getItem('accessToken');

      // If token exists, add it to the Authorization header
      if (accessToken) {
        // Initialize headers object to add access token from localStorage
        config.headers = {
          Authorization: `Bearer ${accessToken}`,
          ...config.headers, // if access token already exist in headers, use the pre-exist one
        };
      }

      return config;
    },
  ],
};
